<mat-form-field [class.mat-mdc-form-field-invalid]="control?.touched && control?.invalid">
  <mat-label *ngIf="label">{{ label | translate }}<span *ngIf="isRequired(control)"> *</span></mat-label>
  <wai-form-file-input
    [forcedDisabled]="forcedDisabled"
    [forceEnabled]="forceEnabled"
    [accept]="accept"
    [deleteCountdown]="deleteCountdown"
    [state]="state"
    [formControl]="control"
    (fileChange)="onFileChange($event)"
    (fileOpen)="onFileOpen($event)"
  ></wai-form-file-input>
  <mat-hint>{{ hint | translate }}</mat-hint>
  <!-- Input of type file is not compatible with <mat-error> so simulate it -->
  <div class="mat-error"><wai-form-error [formField]="control"></wai-form-error></div>
</mat-form-field>
